import { render } from "./DependsTable.vue?vue&type=template&id=1d8dee93&scoped=true"
import script from "./DependsTable.vue?vue&type=script&lang=ts"
export * from "./DependsTable.vue?vue&type=script&lang=ts"

import "./DependsTable.vue?vue&type=style&index=0&id=1d8dee93&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d8dee93"

export default script